export default "__VITE_ASSET__DXYrGzuo__"